import type {ReactElement} from 'react';
import {useAiChat} from '@AiChat/providers/ai-chat.context';
import {useAiChatSize} from '@AiChat/hooks/useAiChatSize';
import {useAiChatSeason} from '@AiChat/hooks/useAiChatSeason';
import {AiChatSeason} from '@AiChat/lib/ai-chat-season-library.types';
import {AiChatHalloweenPumpkins} from '@AiChat/components/ai-chat-halloween-pumpkins/ai-chat-halloween-pumpkins';
import {assertNever} from '@Utils/assert-never.util';
import styles from './ai-chat-seasonal-prompt-box-decorations.module.scss';

export function AiChatSeasonalPromptBoxDecorations(): ReactElement | null {
  const {state} = useAiChat();
  const {isSmall} = useAiChatSize();
  const season = useAiChatSeason();

  if (!season || !isSmall || !state.isReturningUser) {
    return null;
  }

  switch (season) {
    case AiChatSeason.HALLOWEEN:
      return <AiChatHalloweenPumpkins pumpkinSetClasses={styles.pumpkins} />;
    default:
      return assertNever(season);
  }
}
